<div class="row">
    <div class="col-12">
        <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
            <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="gap: 10px">
                <h3 class="fs-4 fw-bold mb-0">Search Player</h3>
                <div class="d-flex flex-column col-md-2 col-12">
                    <input class="form-control" type="text" id="code" name="code" #code="ngModel" [(ngModel)]="data.code" placeholder="Player Code" minlength="3" />
                    <div *ngIf="f.submitted && code.invalid" class="invalid-feedback">
                        <div *ngIf="code.errors.minlength">You must enter at least 3 characters</div>
                    </div>
                </div>
                <div class="d-flex flex-column col-md-2 col-12">
                    <input class="form-control" type="text" id="name" name="name" #name="ngModel" [(ngModel)]="data.name" placeholder="Player Name" minlength="3" />
                    <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                        <div *ngIf="name.errors.minlength">You must enter at least 3 characters</div>
                    </div>
                </div>
                <div class="d-flex flex-column col-md-2 col-12">
                    <input class="form-control" type="text" id="mobile" name="mobile" #mobile="ngModel" [(ngModel)]="data.mobile" placeholder="Player Mobile" minlength="3" />
                    <div *ngIf="f.submitted && mobile.invalid" class="invalid-feedback">
                        <div *ngIf="mobile.errors.minlength">You must enter at least 3 characters</div>
                    </div>
                </div>
                <div class="d-flex flex-row" style="gap: 5px">
                    <button type="submit" class="btn btn-primary">Search</button>
                    <button type="button" class="btn btn-outline-primary" (click)="reset()">Reset</button>    
                </div>
            </div>
            <div *ngIf="f.submitted && !mobile.value && !name.value && !code.value" class="invalid-feedback">
                <p>You have to enter a fields to search.</p>
            </div>
        </form>
    </div>
</div>
<hr/>
<div class="row">
    <div class="col-12">
        <app-table #table></app-table>
    </div>
</div>
